import React from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { SingleInputField } from "../../../components";
import { signUpData } from "../../../assets/lib/login";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#fff",
  },
  box: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    width: "100%",
    maxWidth: "450px",
    boxShadow: "0 0 15px rgba(0,0,0,0.05)",
  },
  title: { fontSize: "24px", fontWeight: "bold", textAlign: "center" },
  subtitle: { fontSize: "16px", textAlign: "center", color: "#555" },
  inputContainer: { display: "flex", flexDirection: "column", gap: "10px" },
  errorText: { color: "red", fontSize: "14px", textAlign: "center" },
  link: {
    color: "#007BFF",
    cursor: "pointer",
    textDecoration: "underline",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
});

const Layout = (props) => {
  const {
    submitLoading,
    signUpState,
    errorFields,
    getSignUpInput,
    handleSendEmailOtp,
    verifyEmailOtp,
    emailOtp,
    emailVerified,
    invalidCompanyEmail,
    campusDisabled,            // ✅ NEW
    emailInvalidOtp,
    handleSendSmsOtp,
    handleSubmitSignUp,
    otp,
    isInvalidOtp,
    phoneNoNot10Digit,
    alpinNot4Digit,
    existingUser,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      {submitLoading && (
        <CircularLoader isPoistionAbsolute zIndex={3} />
      )}

      <div className={classes.box}>
        <h1 className={classes.title}>Welcome to Alpaago</h1>
        <p className={classes.subtitle}>Create your account</p>

        <div className={classes.inputContainer}>
          <SingleInputField
            content={signUpData.userName}
            value={signUpState.userName}
            getInputData={getSignUpInput}
            errorFields={errorFields}
          />

          <SingleInputField
            content={signUpData.email}
            value={signUpState.email}
            getInputData={getSignUpInput}
            errorFields={errorFields}
            isEditable={!emailOtp}
          />

          {/* ❌ Company not found */}
          {invalidCompanyEmail && (
            <p className={classes.errorText}>
              ❌ Company email not found
            </p>
          )}

          {/* ❌ Campus disabled */}
          {campusDisabled && (
            <p className={classes.errorText}>
              🚫 Your organization access is disabled. Please contact your administrator.
            </p>
          )}

          {/* Send Email OTP */}
          {!emailOtp && !campusDisabled && (
            <Button
              variant="contained"
              sx={{ bgcolor: "#000", color: "#fff" }}
              onClick={handleSendEmailOtp}
            >
              Send Email OTP
            </Button>
          )}

          {/* Verify Email OTP */}
          {emailOtp && !emailVerified && !campusDisabled && (
            <>
              <SingleInputField
                content={signUpData.emailOtp}
                value={signUpState.emailOtp}
                getInputData={getSignUpInput}
              />
              {emailInvalidOtp && (
                <p className={classes.errorText}>❌ Invalid Email OTP</p>
              )}
              <Button
                variant="contained"
                sx={{ bgcolor: "#000", color: "#fff" }}
                onClick={verifyEmailOtp}
              >
                Verify Email OTP
              </Button>
            </>
          )}

          {/* Phone + Alpin */}
          {emailVerified && !campusDisabled && (
            <>
              <SingleInputField
                content={signUpData.phoneNumber}
                value={signUpState.phoneNumber}
                getInputData={getSignUpInput}
                errorFields={errorFields}
                isEditable={!otp}
              />

              <SingleInputField
                content={signUpData.newAlpin}
                value={signUpState.newAlpin}
                getInputData={getSignUpInput}
                errorFields={errorFields}
                isEditable={!otp}
              />

              {phoneNoNot10Digit && (
                <p className={classes.errorText}>
                  ❌ Phone must be 10 digits
                </p>
              )}
              {alpinNot4Digit && (
                <p className={classes.errorText}>
                  ❌ Alpin must be 4 digits
                </p>
              )}
              {existingUser && (
                <p className={classes.errorText}>
                  ⚠️ Phone already registered
                </p>
              )}

              {!otp && (
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#000", color: "#fff" }}
                  onClick={handleSendSmsOtp}
                >
                  Send Phone OTP
                </Button>
              )}
            </>
          )}

          {/* Final Submit */}
          {!!otp && !campusDisabled && (
            <>
              <SingleInputField
                content={signUpData.otp}
                value={signUpState.otp}
                getInputData={getSignUpInput}
              />
              {isInvalidOtp && (
                <p className={classes.errorText}>❌ Invalid SMS OTP</p>
              )}

              <Button
                variant="contained"
                sx={{ bgcolor: "#000", color: "#fff" }}
                onClick={handleSubmitSignUp}
              >
                Submit
              </Button>
            </>
          )}

          <p style={{ textAlign: "center" }}>
            Already have an account?{" "}
            <span
              className={classes.link}
              onClick={() => navigate(routes.USER_LOGIN)}
            >
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Layout;
